import { css } from '@emotion/react';
import type { ReactNode } from 'react';

const tableStyle = css({
  width: '100%',
  borderSpacing: 0,
});

type ExportReportTableProps = Readonly<{
  children: ReactNode;
  className?: string;
}>;

export const ExportReportTableComponent = (props: ExportReportTableProps) => {
  return (
    <table css={tableStyle} className={props.className}>
      {props.children}
    </table>
  );
};
